import {Module} from '@fantasmagames/slot/src/common/Module';
import {MainMenuEvents} from '@fantasmagames/slot/src/modules/mainmenu/MainMenuEvents';
import {BetlevelMenuEvents} from '@fantasmagames/slot/src/modules/popupmenus/betmenu/BetlevelMenuEvents';
import {GameViews} from 'src/GameViews';
import {PaytableView} from 'src/paytable/PaytableView';
import {LogicEvents} from '@fantasmagames/slot/src/logic/LogicEvents';

export class PaytableModule extends Module<PaytableView> {
	protected setupStates(): void {}

	protected enterFirstState(): void {}

	public init(): void {
		super.init();

		this.view.paytableValues = this.logic.paytable;
		// this.view.buildPages();
	}

	protected setupViews(): void {
		this.setView(GameViews.PAYTABLE_VIEW);
	}

	protected setupEvents(): void {
		super.setupEvents();

		this.on(MainMenuEvents.MAIN_MENU_PAYTABLE_OPEN, this.showPaytable);
		this.on(MainMenuEvents.MAIN_MENU_SETTINGS_OPEN, this.hidePaytable);
		this.on(MainMenuEvents.MAIN_MENU_INFO_OPEN, this.hidePaytable);
		this.on(MainMenuEvents.MAIN_MENU_CLOSED, this.hidePaytable);

		this.on(BetlevelMenuEvents.BET_VALUE_UPDATED, this.onBetValueUpdated);

		this.on(LogicEvents.INIT_RESPONSE, this.onInitResponseReceived);
	}

	protected showPaytable(): void {
		this.view.show();
	}

	protected hidePaytable(): void {
		this.view.hide();
	}

	protected onInitResponseReceived(): void {
		this.onBetValueUpdated();
	}

	protected onBetValueUpdated(): void {
		const buffer: number = 10000;

		let multiplier = this.logic.betValue / 20;
		multiplier = Math.floor(multiplier * buffer) / buffer;

		this.updatePaytableValues(multiplier);
	}

	protected updatePaytableValues(multiplier: number): void {
		this.view.paytableValues = this.logic.paytable;

		this.view.updatePaytable(multiplier);
	}
}



// WEBPACK FOOTER //
// ./src/paytable/PaytableModule.ts